"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeamV3PoolCode = void 0;
const chain_1 = require("@zenlink-interface/chain");
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const viem_1 = require("viem");
const HEXer_1 = require("../../HEXer");
const PoolCode_1 = require("./PoolCode");
class BeamV3PoolCode extends PoolCode_1.PoolCode {
    constructor(pool, providerName) {
        super(pool, providerName);
        this.executor = {
            [chain_1.ParachainId.MOONBEAM]: '0xb9b81c5335d72416430455fc052Ec8A2339486aB',
        };
    }
    getStartPoint() {
        return PoolCode_1.PoolCode.RouteProcessorAddress;
    }
    getProtocolExecutor() {
        const chainId = this.pool.token0.chainId;
        (0, tiny_invariant_1.default)(chainId !== undefined, 'BeamV3PoolCode: Unseted chainId');
        return this.executor[Number(chainId)];
    }
    getProtocolExecutorStartPoint() {
        return this.getProtocolExecutor();
    }
    getSwapCodeForRouteProcessor(_leg, _route, _to) {
        return 'unsupported';
    }
    getSwapCodeForRouteProcessor2(_leg, _route, _to) {
        return 'unsupported';
    }
    getSwapCodeForAggregationRouter(leg, _route, to) {
        const code = new HEXer_1.HEXer()
            .address(this.getProtocolExecutor())
            .bytes((0, viem_1.encodeAbiParameters)((0, viem_1.parseAbiParameters)('address, bool, address'), [
            this.pool.address,
            leg.tokenFrom.address === this.pool.token0.address,
            to,
        ]))
            .toString();
        return code;
    }
}
exports.BeamV3PoolCode = BeamV3PoolCode;
